import React, { useEffect, useRef } from 'react'
import ReactDom from 'react-dom'
import './Drawer.scss'
import { ResponsiveSVG } from 'ui/acro'
import closeSVG from '../../../assets/images/X.svg'
import styled from 'styled-components'
import { LIKED_ITEMS_SLUG } from 'components_v1/common'

const HeaderWrapper = styled.div`
  .Close {
    width: fit-content;
  }
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  width: 90%;
  justify-content: space-between;
`

const Drawer = ({
  isOpen,
  onClose,
  title,
  children,
  dataObj,
  author,
  uuid
}) => {
  const [domReady, setDomReady] = React.useState(false)
  const ref = useRef(null)
  const planData = dataObj?.type === 'SERIES' ? dataObj : dataObj?.plan
  const instructorName = planData?.coaches?.map(
    (coach) => `${coach.firstName} ${coach.lastName}`
  )[0]

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose, ref])

  React.useEffect(() => {
    setDomReady(true)
  }, [])
  const containerClass = isOpen ? 'Container' : 'Container Close'
  const drawerClass = isOpen ? 'Drawer Right Open' : 'Drawer Right Close'
  return domReady
    ? ReactDom.createPortal(
        <div>
          <div className={containerClass} />

          <div ref={ref} className={drawerClass}>
            <div className='header'>
              <HeaderWrapper className='headerWrapper'>
                {author?.firstName || instructorName ? (
                  <div className='text-box'>
                    <h4 className='title'>{title}</h4>
                    {author?.firstName && uuid !== LIKED_ITEMS_SLUG ? (
                      <p className='author'>
                        {`${author?.firstName} ${author?.lastName}`}
                      </p>
                    ) : (
                      <p className='author'>{`${instructorName}`}</p>
                    )}
                    <p className='author'>
                      {`${planData?.primaryCategory?.title} / ${planData?.subcategory?.title} • ${dataObj?.difficultyLevel}`}
                    </p>

                    <p className='series'>{`Program: ${dataObj?.title}`}</p>
                  </div>
                ) : (
                  <h4 className='title'> {title}</h4>
                )}

                <div className='Close' onClick={onClose}>
                  <ResponsiveSVG
                    SVG={closeSVG}
                    style={{
                      cursor: 'pointer'
                    }}
                    width='24px'
                    height='24px'
                  />
                </div>
              </HeaderWrapper>
            </div>

            <div className='Content'>{children}</div>
          </div>
        </div>,
        document.body
      )
    : null
}
export default Drawer
